import { render } from "./Developers.vue?vue&type=template&id=d0c4193a&scoped=true"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"

import "./Developers.vue?vue&type=style&index=0&id=d0c4193a&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c4193a"]])

export default __exports__